export default __webpack_public_path__ + "assets/uv-index-11.e8918bd4.svg";